import {useRef, useCallback} from 'react'
import {createDebugger} from '../helpers/Debugger'

const debug = createDebugger({namespace: 'useCustomShapeCache'})

/**
 * Map-based cache for custom shape preview results.
 * Keys: `${side}:${attributeId}:${designsFingerprint}`
 * Values: data URL strings (PNG)
 *
 * Max 2 entries (front + back), ~100-500KB each.
 */
export function useCustomShapeCache() {
    const cacheRef = useRef(new Map())

    const get = useCallback((key) => {
        debug.debug('get', {key, hit: cacheRef.current.has(key)})
        return cacheRef.current.get(key) ?? null
    }, [])

    const set = useCallback((key, value) => {
        debug.debug('set', {key, hit: cacheRef.current.has(key)})
        cacheRef.current.set(key, value)
    }, [])

    const del = useCallback((key) => {
        debug.debug('del', {key, hit: cacheRef.current.delete(key)})
    }, [])

    const clear = useCallback(() => {
        debug.debug('clear')
        cacheRef.current.clear()
    }, [])

    return {get, set, del, clear}
}

